import {
    HorizAlignment,
    ISearch,
    ISearchProfile,
    ISearchProvider,
    ISearchProviderField,
    ISearchRequestSubset,
    SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PASearch} from "../PA.Core/PASearch";
import {PAEnvironment} from "../PA.Core/PAEnvironment";

const vUI_Job_Processor_Search_Fields: {[id:string]: ISearchProviderField } = {
    WB_JOBPROCESSOR_ID:     {type: SearchProviderFieldType.number,  renderOptions: { columnName: 'Id',             columnResourceName: 'colId',              alignment: HorizAlignment.Right}, domainOptions: { maxLength: 50}},
    JOBPROCESSOR_IDX:       {type: SearchProviderFieldType.number,  renderOptions: { columnName: 'Processor Idx',  columnResourceName: 'colIdx',   alignment: HorizAlignment.Right}, domainOptions: { maxLength: 50}},
    JOBPROCESSOR_HOSTNAME:  {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'HostName',       columnResourceName: 'colName',        alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
    JOBPROCESSOR_PID:       {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Process PID',    columnResourceName: 'colProductId',             alignment: HorizAlignment.Center, columnWidthCharacters: 20}, domainOptions: {}},
    JOB_TYPE:               {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Job Type',       columnResourceName: 'colType',        alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
    JOBPROCESSOR_STATUS:    {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Status',                columnResourceName: 'colStatus',          alignment: HorizAlignment.Left},   domainOptions: {maxLength: 50}},
    JOBPROCESSOR_HB_DTTS:   {type: SearchProviderFieldType.number, renderOptions:  { columnName: 'HB Date',               columnResourceName: 'colHB_Date',         alignment: HorizAlignment.Left},   domainOptions: { maxLength: 50}},
    CREATED_DTTS:     {type: SearchProviderFieldType.sapdate, renderOptions: { columnName: 'Created Date', columnResourceName: 'colCreatedDate', alignment: HorizAlignment.Center}, domainOptions: {}},
    MODIFIED_DTTS:     {type: SearchProviderFieldType.sapdate, renderOptions: { columnName: 'Modified Date', columnResourceName: 'colModifiedDate', alignment: HorizAlignment.Center}, domainOptions: {}},
    DELETED_IND:            {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Deleted Ind',           columnResourceName: 'colDeletedInd',      alignment: HorizAlignment.Left},   domainOptions: {}},
    DELETED_DT:             {type: SearchProviderFieldType.sapdate, renderOptions: { columnName: 'Deleted Date',          columnResourceName: 'colDeleted_Date',    alignment: HorizAlignment.Center}, domainOptions: { maxLength: 50}}
}

const JobProcessorSearchProviderBasic: ISearchProvider = {

    keyFields: {id:    'WB_JOBPROCESSOR_ID',
        id_ui: 'JOBPROCESSOR_PID',
        name:  'JOBPROCESSOR_HOSTNAME'
    },

    searchProviderFields: vUI_Job_Processor_Search_Fields,

    search(searchOptions: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {

            let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                'vUI_Job_Processor_Search',
                this.searchProviderFields,
                [])

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(res)
                })
                .catch((err)=> {
                    error(err)
                })
        })
    }
}

const JobProcessorSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: { ui5ResourceId: "JobProcessorSearchProfileByName"},

    profileFilter: [
        {profileFilterName: 'PID',     searchProviderFieldId: 'JOBPROCESSOR_PID', renderOptions: { }},
        {profileFilterName: 'Name',   searchProviderFieldId: 'JOBPROCESSOR_HOSTNAME', renderOptions: { }}
    ],  // ISearchFields
    profileDisplayFields: [
        'JOB_TYPE','JOBPROCESSOR_IDX', 'JOBPROCESSOR_HOSTNAME', 'JOBPROCESSOR_PID', 'JOBPROCESSOR_STATUS',
        'CREATED_DTTS', 'MODIFIED_DTTS'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: JobProcessorSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];

}

const JobProcessorSearch: ISearch = {
    searchName: "Find Job Processor",
    renderOptions: { ui5ResourceId: "JobProcessorSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [JobProcessorSearchProfileByName]
}
PAEnvironment.registerBusinessObjectSearch("JobProcessorBO", "JobProcessor", JobProcessorSearch, "Job Processor Search")

export {JobProcessorSearch}